var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { Subject, BehaviorSubject } from 'rxjs';
import { skip } from 'rxjs/operators';
import { ToolbarBuilder } from '../helpers/toolbar.builder';
var ToolbarService = /** @class */ (function () {
    function ToolbarService() {
        this.events = {};
        this.toolbarSubject$ = new BehaviorSubject(new ToolbarBuilder().build());
    }
    ToolbarService.singleton = function () {
        if (!ToolbarService.toolbarService) {
            ToolbarService.toolbarService = new ToolbarService();
        }
        return ToolbarService.toolbarService;
    };
    ToolbarService.prototype.subscribeToToolbar = function (callback) {
        return this.toolbarSubject$.asObservable().pipe(skip(1)).subscribe(function (value) {
            callback(value);
        });
    };
    ToolbarService.prototype.setToolbarToDefault = function () {
        this.setToolbarConfig(new ToolbarBuilder().build());
    };
    ToolbarService.prototype.setToolbarConfig = function (toolbarConfig) {
        var _this = this;
        this.validateToolbarConfig(toolbarConfig);
        if (toolbarConfig.eventButtons) {
            if (toolbarConfig.eventButtons.length > 0) {
                toolbarConfig.eventButtons.forEach(function (eventButton) {
                    _this.events[eventButton.name] = new Subject();
                    _this.subscribeToEventButton(eventButton.name, eventButton.callback);
                });
            }
            else {
                this.completeAllEventButtons();
            }
        }
        var currentToolbarConfig = this.toolbarSubject$.getValue();
        var newToolbarConfig = __assign(__assign({}, currentToolbarConfig), toolbarConfig);
        this.toolbarSubject$.next(newToolbarConfig);
    };
    ToolbarService.prototype.validateToolbarConfig = function (toolbarConfig) {
        if (!toolbarConfig || typeof toolbarConfig !== 'object') {
            throw new Error('A configuração da toolbar precisa ser um objeto. (ToolbarConfig)');
        }
        Object.keys(toolbarConfig).forEach(function (key) {
            if (key !== 'displayNavigationTitle' && key !== 'buttons' && key !== 'eventButtons') {
                throw new Error("A configura\u00E7\u00E3o da toolbar n\u00E3o pode conter a chave ".concat(key));
            }
        });
        if (toolbarConfig.buttons) {
            Object.keys(toolbarConfig.buttons).forEach(function (key) {
                if (key !== 'search' && key !== 'return' && key !== 'help') {
                    throw new Error("O bot\u00E3o ".concat(key, " \u00E9 inv\u00E1lido."));
                }
                else if (typeof toolbarConfig.buttons[key] !== 'boolean') {
                    throw new Error("O bot\u00E3o ".concat(key, " precisa ser um booleano."));
                }
            });
        }
        if (toolbarConfig.eventButtons && toolbarConfig.eventButtons.length > 0) {
            toolbarConfig.eventButtons.forEach(function (eventButton) {
                if (!eventButton.name || !eventButton.icon || !eventButton.callback) {
                    throw new Error('A configuração do botão precisa contar com o nome, o ícone e o callback. (name, icon, callback)');
                }
            });
        }
        if (toolbarConfig.displayNavigationTitle && typeof toolbarConfig.displayNavigationTitle !== 'boolean') {
            throw new Error('O displayNavigationTitle precisa ser um booleano.');
        }
    };
    ToolbarService.prototype.subscribeToEventButton = function (name, callback) {
        var tempSubject = this.events[name];
        if (tempSubject) {
            return tempSubject.subscribe(function (value) {
                callback(value);
            });
        }
    };
    ToolbarService.prototype.completeAllEventButtons = function () {
        Object.values(this.events).forEach(function (subject) {
            subject.complete();
        });
    };
    return ToolbarService;
}());
export { ToolbarService };
